// 个人中心资源位管理
import http from "@/jslibs/axios/http";

// 个人中心资源位更新
export const edit = (data) => http.post("/v1/cms/PersonResource", data);

// 个人中心资源位详情
export const detail = (data) => http.get("/v1/cms/PersonResource", data);
